import React from 'react';
import Textarea from 'react-textarea-autosize';
import classNames from 'classnames';
export default class TextAreaWrapper extends React.Component {

  state = {value: ''};

  componentWillReceiveProps = newProps => {
    if(newProps.value.length <= 1000)
      this.setState({value: newProps.value, errors: newProps.error });

    else
      this.setState({value: newProps.value.substr(0,1000), errors: newProps.error });

  };

  handleChange = e => {
    if(this.state.value.length <= 1000)
      this.props.handleChange({[this.props.name]: e.target.value});
    else
      this.props.handleChange({[this.props.name]: e.target.value.substr(0,1000)});

  };

  isArray = () => {
    if(this.state.errors)
      return Array.isArray(this.state.errors.slice());
    else
      return false
  };

  render(){
    return(
      <div className={classNames('custom-text-area input-holder animate', {'has-error': this.state.errors })}
           style={{height: 'auto',position: 'relative'}}>
        <Textarea
          id={this.props.name}
          minRows={2}
          className='animate-input'
          value={this.state.value}
          onChange={this.handleChange}
          style={{lineHeight: 2}}
        />
        <label htmlFor={this.props.name} className="animate-label" style={{top: -5}}>{this.props.placeholder}</label>
        <span className="text-counter" style={{position: 'absolute',
          right: 10,
          bottom: -10,
        color: 'rgba(0, 0, 0, 0.54)',
          fontSize: 12}}> {this.state.value.length}/1000</span>
        <span className="bar" style={{marginBottom: 10}}/>
        <span className="error-text"
        style={{
          position: 'absolute',
          marginTop: 0,
          left: 0,
          bottom: -7,
        }}>{this.isArray() ?  this.state.errors.join(', ') : null}</span>

      </div>
    )
  }


}



// WEBPACK FOOTER //
// ./src/blocks/TextAreaWrapper.jsx